import { render } from "./Thesis.vue?vue&type=template&id=667925ee&scoped=true"
import script from "./Thesis.vue?vue&type=script&lang=js"
export * from "./Thesis.vue?vue&type=script&lang=js"

import "./Thesis.vue?vue&type=style&index=0&id=667925ee&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667925ee"]])

export default __exports__